<template>

  <button @click="getCreditosOptimizados()" class="btn dashboard-action-btn">
    Generar Excel <i class="fa-solid fa-download"></i>
  </button>


</template>

<script>
import ExcelJS from "exceljs";
import { solicitudCompleta } from '../solicitud.js'
import Security from "../security";
import Swal from "sweetalert2";
import direccionData from '../solicitud/direccionData.json';

// import Security from '../security';
export default {
  name: "Cartera-App",
  data() {
    return {

      imgPath: process.env.VUE_APP_IMAGE_URL,
      slug: "",
      noCuenta: '',
      numerosDeCuenta: [],
      esRefinanciado: false,
      nombreBanco: '',
      fechaPagado: '',
      moneda: 'lps',
      departamentos: [],
      montoPagado: 0,
      idCredito: 0,
      fechaUltimoPago: '',
      isLoading: false,
      sendImageToServer: false,
      fechaDataUltimoPago: '',
      noReferenciaRecibo: '',
      recibo: null,
      estado: 'Activo',
      hacerPagoInfo: {},
      solicitudCompleta,
      creditos: [],
      creditosOptimizados: [],
      data: [],
      dateFormated: "",
      ready: false,
      imagenPegada: null,
      readyExcel: false,
      filtradoMostrar: "",
      verMasData: [],
      depto: '',
      solicitud: {},
      sucursalesRoles: [],
      pagos: [],
      sucursal: '',
      roles: ['Coordinacion', 'Admin', 'Finanzas', 'Asesor', 'Cordinador Sucursal', 'Consultor'],
      Finanzas: false,
      Admin: false,
      Coordinacion: false,
      Asesor: false,
      coordinadorSucursal: false,
      modoThanos: false,
      Consultor: false,
      readyVerMas: false,
      userRoles: [],

      contadorArchivos: 0,
    };
  },
  props: {
    sucursalFiltro: String,
    estadoFiltro: String,
    asesorFiltro: String,
    reporteFiltro: String,
  },

  beforeMount() {


    this.userRoles = Security.getUserRoles();
    // console.log(this.userRoles);
    this.roles.forEach(element => {

      if (this.userRoles[0]?.some(role => role.includes(element)) === true) {
        this[element] = true;
      } else if (this.userRoles[0]?.some(role => role.includes('Coordinador Sucursal')) === true) {
        this.coordinadorSucursal = true;
        // console.log('coordinador sucursal en true')
      } else if (this.userRoles[0]?.some(role => role.includes('Modo Thanos')) === true) {
        this.modoThanos = true;
        // console.log('Modo thanos en true')
      }
      /*       if (this.userRoles[0]?.some(role => role.includes('Coordinador Sucursal')) === true) {
            } */


    });

    this.sucursalesRoles = Security.getUserSucursal()
    //Sucursales
    this.sucursal = 'MOSTRAR TODAS'
    if (this.Admin || this.coordinador) {
      this.departamentos = direccionData[0].departamentos
    } else {
      // console.log('Sucursales de La persona');
      const sucursales = Security.getUserSucursal();
      this.departamentos = sucursales[0];
    }

    console.log("Departamentos", this.departamentos);

    // this.getCreditosOptimizados()


  },
  updated() {

  },

  methods: {

    comprobarEstado(estado) {
      if (this.mayusculasSinEspacios(estado) === 'CANCELADO') {
        return true
      } else return false
    },
    //Convertir numero negativo a 0
    convertirANoNegativo(numero) {
      // Si el número es negativo, convertirlo a cero
      if (numero < 0) {
        return 0;
      } else {
        return numero;
      }
    },
    // Manejo de la impresión del Excel
    handleImprimir() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(this.depto ? this.depto[0] : "Data");
      worksheet.columns = [
        { header: "Fecha Data", key: "fechaData", width: 11 },
        { header: "Número Prestamo", key: "noPrestamo", width: 22 },
        { header: "Número Prestamo Original", key: "noPrestamoOriginal", width: 22 },
        { header: "Cartera", key: "tipoCartera", width: 14 },
        { header: "Asesor", key: "asesor", width: 20 },
        { header: "Identidad", key: "dni", width: 20 },
        { header: "Nombre Completo", key: "nombres", width: 40 },

        { header: "Fecha de otorgamiento", key: "fechaOtorgamiento", width: 15 },
        { header: "Fecha de Vencimiento", key: "fechaVencimiento", width: 15 },
        { header: "Monto Aprobado", key: "montoOtorgado", width: 20 },
        { header: "Producto Financiero", key: "producto", width: 20 },
        { header: "Tasa de Interes ", key: "interes", width: 10 },
        { header: "Plazo en meses", key: "plazoPago", width: 15 },
        { header: "Número de cuota", key: "noCuotasPlan", width: 15 },
        { header: "Valor de la cuota", key: "valorCuota", width: 15 },
        { header: "Frecuencia de pago", key: "frecuenciaPago", width: 20 },
        { header: "Estado Crédito", key: "estado", width: 20 },
        
        { header: "Saldo de Capital", key: "saldoCapital", width: 20 },
        { header: "Saldo Capital Vencido", key: "capitalAtrasado", width: 20 },
        { header: "Saldo Interes corriente (A la fecha)", key: "saldoInteres", width: 20 },
        { header: "Saldo Intreres Moratorio(A la fecha)", key: "saldoMora", width: 20 },
        { header: "Total Saldo Vencido A La Fecha", key: "totalSaldoVencidoALaFecha", width: 20 },
        { header: "Total Saldo Adeudado", key: "totalSaldoAdeudado", width: 20 },
        { header: "Dias Mora", key: "diasMora", width: 10 },
        { header: "Dias Cuota sin Pagar", key: "diasCuotaSinPagar", width: 10 },
        { header: "Fecha Última de pago", key: "fechaUltimoPago", width: 20 },
        { header: "Fecha Ultima Cuota Pagada", key: "fechaUltimaCuotaPagada", width: 20 },
        
        { header: "Cuotas Pagadas", key: "cuotasPagadas", width: 20 },
        { header: "Capital Pagado", key: "capitalAcumulado", width: 20 },
        { header: "Interes Pagado", key: "totalInteresPagado", width: 20 },
        { header: "Total Pagado", key: "totalPagado", width: 20 },
        { header: "Total Recibos Posteados", key: "totalRecibos", width: 20 },
        { header: "Posee saldo Inicial", key: "saldoInicial", width: 20 },


        { header: "Sexo", key: "sexo", width: 10 },
        { header: "Fecha Nacimiento", key: "fechaNacimiento", width: 15 },
        { header: "Es Localizable", key: "esLocalizable", width: 10 },
        { header: "Proceso", key: "estadoProceso", width: 15 },
        { header: "Departamento", key: "sucursal", width: 20 },
        { header: "Municipio", key: "municipio", width: 20 },
        { header: "Coordenadas", key: "referenciaGeografica", width: 50 },
        { header: "Direccion Personal", key: "puntoReferencia", width: 50 },
        { header: "Teléfono", key: "telefono", width: 20 },
        { header: "Tipo Credito", key: "tipoCredito", width: 15 },
        { header: "Categoría Riesgo Cliente", key: "riesgo", width: 10 },
        { header: "Garantía", key: "garantia", width: 10 },
        { header: "EsRefinanciado", key: "esRefinanciado", width: 10 },
        { header: "Saldo Seguro Deuda", key: "seguroDeuda", width: 15 },
        { header: "Saldo Seguro Daño", key: "seguroDaño", width: 15 },
        { header: "Seguro Vehiculo/Maquinaria", key: "seguroVehiculo", width: 15 },

        // { header: "Comprobar Estado", key: "combrobarEstado", width: 20 },
        // { header: "Otros", key: "otros", width: 20 },
        // { header: "Categoría Crédito", key: "categoria", width: 10 },
        // { header: "Cuotas Mora", key: "cuotasMora", width: 20 },


      ];
      worksheet.getRow(1).font = { bold: true };


      const mappedData = this.creditos.map((credito) => ({
        // id: credito.id,
        fechaData: new Date().toISOString().slice(0, 10),
        noPrestamo: credito.noPrestamo,
        noPrestamoOriginal: credito.noPrestamoOriginal,
        tipoCartera: credito.tipoCartera,
        asesor: credito.nombreAsesor,
        dni: credito.cliente.dni,
        nombres: credito.cliente.nombres + " " + (credito.cliente.apellidos ? credito.cliente.apellidos : ""),
        
        fechaOtorgamiento: new Date(credito.fechaOtorgamiento),
        fechaVencimiento: new Date(credito.fechaVencimiento),
        montoOtorgado: + credito.montoOtorgado,
        producto: credito.solicitud.producto,
        interes: credito.solicitud.interes + "%",
        plazoPago: credito.solicitud.plazoPago + " " + "Meses",
        noCuotasPlan: credito.totalCuotasPagar2,
        valorCuota: credito.valorCuota,
        frecuenciaPago: credito.solicitud.frecuenciaPago,
        estado: this.mayusculasSinEspacios(credito.estado),
        
        saldoCapital: (credito.saldo > 0 ? credito.saldo : 0),
        capitalAtrasado: (credito.simularPagoHoy.capitalDebePagar > 0 ? credito.simularPagoHoy.capitalDebePagar : 0),
        saldoInteres: (credito.simularPagoHoy.saldoInteres > 0 ? credito.simularPagoHoy.saldoInteres : 0), //Pendiente Simulador
        saldoMora: credito.simularPagoHoy.saldoMora, //Pendiente Simulador
        totalSaldoVencidoALaFecha: this.convertirANoNegativo(credito.simularPagoHoy.minimoDebePagarCuota), //Pendiente Simulador
        totalSaldoAdeudado: this.convertirANoNegativo(credito.saldo + (credito.simularPagoHoy.saldoInteres > 0 ? credito.simularPagoHoy.saldoInteres : 0) + credito.simularPagoHoy.saldoMora), //Pendiente Simulador
        diasMora: ((this.compareStrings(credito.estado, "cancelado")) ? 0 : credito.simularPagoHoy.diasMora),//Pendiente Simulador
        diasCuotaSinPagar: ((this.compareStrings(credito.estado, "cancelado")) ? 0 : credito.simularPagoHoy.diasCuotaSinPagar),
        fechaUltimoPago: new Date(credito.fechaUltimaPago),
        fechaUltimaCuotaPagada: new Date(credito.simularPagoHoy.fechaUltimaCuotaPagada), //Pendiente
        
        cuotasPagadas: credito.noCuotas - 1, //Pendiente
        capitalAcumulado: (this.comprobarEstado(credito.estado)) ? credito.montoOtorgado : credito.capitalAcumulado,
        totalInteresPagado: credito.totalInteresPagado,
        totalPagado: credito.totalPagado+credito.totalArrInteresPagado,
        totalRecibos: credito.totalRecibos,
        saldoInicial: ((credito.totalPagado+credito.totalArrInteresPagado) === credito.totalRecibos) ? "No tiene saldo inicial" : "Si tiene saldo inicial",


        sexo: credito.infoRegistro.sexo,
        fechaNacimiento: new Date(credito.infoRegistro.fechaNacimiento),
        esLocalizable: (credito.esLocalizable ? "SI" : "NO"),
        estadoProceso: ((credito.estadoProceso === '' || credito.estadoProceso === 'NORMAL') ? 'NORMAL' : credito.estadoProceso),
        sucursal: credito.solicitud.sucursal,
        municipio: credito.cliente.municipio,
        referenciaGeografica: credito.cliente.referenciaGeografica,
        puntoReferencia: credito.cliente.puntoReferencia,
        telefono: credito.cliente.telefono,
        tipoCredito: 'pequeño',
        riesgo: ((credito.esRefinanciado) ? 'SI' : 'NO'),
        garantia: '',
        esRefinanciado: ((credito.esRefinanciado) ? 'SI' : 'NO'),
        seguroDeuda: "N/A",
        seguroDaño: "N/A",
        seguroVehiculo: "N/A",
        
        // combrobarEstado: ((credito.estadoProceso === '') ? 'Falta Comprobar Estado' : "Comprobado"),
        // otros: (this.comprobarEstado(credito.estado)) ? (credito.capitalAcumulado - credito.montoOtorgado) : 0,
        // categoria: '|',
        // cuotasMora: 0, //Pendiente



      }));

      worksheet.getRow(1).font = { bold: true };
      const columnasFecha = [
        'fechaNacimiento',
        'fechaOtorgamiento',
        'fechaVencimiento',
        'fechaUltimoPago',
        'fechaUltimaCuotaPagada'
      ];
      columnasFecha.forEach((key) => {
        worksheet.getColumn(key).numFmt = 'dd/mm/yyyy';
      });


      worksheet.addRows(mappedData);

      // Lo convierte en tabla

      worksheet.addTable({
        name: 'CarteraTable',
        ref: 'A1',
        headerRow: true,
        totalsRow: false,
        style: {
          theme: 'TableStyleMedium2',
          showRowStripes: true,
        },
        columns: worksheet.columns.map(col => ({ name: col.header, filterButton: true })),
        rows: mappedData.map(row => worksheet.columns.map(col => row[col.key])),
      });


      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("hidden", "");
        a.setAttribute("href", url);
        a.setAttribute("download", `CARTERA_${((this.sucursalFiltro == 'MOSTRAR TODAS') ? "COMPLETA" : (this.sucursalesRoles[0] == 'ALL' ? this.sucursalFiltro : this.sucursalesRoles[0])) + "_AXCC" + "_" + this.estadoFiltro + "_" + this.hoy()}.xlsx`);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    },
    
    // Manejo de la impresión del Excel

handleImprimirTransUnion() {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("TRANSUNION");

  // Helpers (para no reventar cuando algo venga null/undefined)
  const s = (v) => (v === null || v === undefined ? "" : String(v)).trim();
  const n = (v) => (isNaN(Number(v)) ? 0 : Number(v));


  worksheet.columns = [
    { header: "TIPO SUJETO", key: "tipoSujeto", width: 14 },
    { header: "NACIONALIDAD", key: "nacionalidad", width: 14 },
    { header: "NOMBRE COMPLETO", key: "nombreCompleto", width: 35 },
    { header: "PRIMER APELLIDO", key: "primerApellido", width: 18 },
    { header: "SEGUNDO APELLIDO", key: "segundoApellido", width: 18 },
    { header: "APELLIDO CASADA", key: "apellidoCasada", width: 16 },
    { header: "PRIMER NOMBRE", key: "primerNombre", width: 18 },
    { header: "SEGUNDO NOMBRE", key: "segundoNombre", width: 18 },
    { header: "CÉDULA", key: "cedula", width: 18 },
    { header: "RTN - carnet residencia - Pasaporte", key: "rtnPasaporte", width: 28 },
    { header: "(ID3)NO APLICA", key: "id3", width: 14 },
    { header: "(ID4)NO APLICA", key: "id4", width: 14 },
    { header: "(ID5)NO APLICA", key: "id5", width: 14 },
    { header: "FECHA NACIMIENTO", key: "fechaNacimiento", width: 16 },
    { header: "SEXO", key: "sexo", width: 10 },
    { header: "ESTADO CIVIL", key: "estadoCivil", width: 14 },

    { header: "DIRECCION RESIDENCIAL", key: "direccionResidencial", width: 35 },
    { header: "DEPARTAMENTO", key: "deptoResidencial", width: 16 },
    { header: "MUNICIPIO", key: "munResidencial", width: 16 },

    { header: "DIRECCION LABORAL", key: "direccionLaboral", width: 30 },
    { header: "DEPARTAMENTO", key: "deptoLaboral", width: 16 },
    { header: "MUNICIPIO", key: "munLaboral", width: 16 },

    { header: "DIRECCION EMAIL", key: "email", width: 25 },
    { header: "TELEFONO RESIDENCIAL", key: "telResidencial", width: 18 },
    { header: "TELEFONO LABORAL", key: "telLaboral", width: 18 },
    { header: "TELEFONO CELULAR", key: "telCelular", width: 18 },

    { header: "TIPO OBLIGACION", key: "tipoObligacion", width: 16 },
    { header: "MONEDA", key: "moneda", width: 10 },
    { header: "IDENTIFICADOR TIPO CUENTA", key: "idTipoCuenta", width: 24 },
    { header: "NUMERO OBLIGACION", key: "numeroObligacion", width: 20 },

    { header: "FECHA DE APERTURA", key: "fechaApertura", width: 16 },
    { header: "FECHA DE VENCIMIENTO", key: "fechaVencimiento", width: 18 },
    { header: "PERIODO PAGO", key: "periodoPago", width: 14 },

    { header: "ESTADO", key: "estado", width: 12 },
    { header: "SUB ESTADO", key: "subEstado", width: 14 },
    { header: "CALIFICACION", key: "calificacion", width: 14 },

    { header: "DIAS MORA", key: "diasMora", width: 10 },
    { header: "VALOR LIMITE", key: "valorLimite", width: 14 },
    { header: "VALOR SALDO TOTAL", key: "saldoTotal", width: 18 },
    { header: "VALOR SALDO MORA", key: "saldoMora", width: 18 },
    { header: "VALOR CUOTA", key: "valorCuota", width: 14 },

    { header: "TIPO DEUDOR", key: "tipoDeudor", width: 14 },
    { header: "TIPO GARANTIA", key: "tipoGarantia", width: 14 },
    { header: "NUMERO GARANTIA", key: "numeroGarantia", width: 16 },
    { header: "VALOR GARANTIA", key: "valorGarantia", width: 14 },
    { header: "DESCRIPCION", key: "descripcion", width: 25 },

    { header: "TASA CAMBIO", key: "tasaCambio", width: 12 },
    { header: "MONTO VENCIDO", key: "montoVencido", width: 14 },
    { header: "MONTO PAGADO", key: "montoPagado", width: 14 },
    { header: "NUEVO LIMITE", key: "nuevoLimite", width: 14 },

    { header: "FECHA DE CASTIGO", key: "fechaCastigo", width: 16 },
    { header: "CREDITO REFERENCIA", key: "creditoReferencia", width: 18 },
    { header: "CREDITO CONSOLIDADO", key: "creditoConsolidado", width: 20 },
    { header: "MONTO CONSOLIDADO", key: "montoConsolidado", width: 18 },

    { header: "IDENTIFICACION6", key: "identificacion6", width: 16 },
    { header: "NOMBRE DE ENTIDAD", key: "nombreEntidad", width: 22 },
  ];

  worksheet.getRow(1).font = { bold: true };

const mappedData = (this.creditos || []).flatMap((credito) => {
  const cliente = credito?.cliente || {};
  const solicitud = credito?.solicitud || {};
  const info = credito?.infoRegistro || {};
  const sim = credito?.simularPagoHoy || {};

  const resultados = [];

  const saldoMora = n(sim?.saldoMora) > 0 ? n(sim?.saldoMora) : 0;

  const nombresFull = `${s(cliente.nombres)} ${s(cliente.apellidos)}`
    .replace(/\s+/g, " ")
    .trim();

  const construirObjeto = (nombreCompleto, cedula, tipoDeudor, direccion, celular) => ({
    tipoSujeto: "F",
    nacionalidad: "HN",

    nombreCompleto: this.limitarTexto(nombreCompleto, 50),
    primerApellido: "",
    segundoApellido: "",
    apellidoCasada: "",

    primerNombre: "",
    segundoNombre: "",

    cedula: this.formatearIdentidad(cedula),
    rtnPasaporte: s(cliente.rtn || ""),

    fechaNacimiento: (tipoDeudor === "IND") ? "" : this.formatearFecha(info.fechaNacimiento),
    sexo: (tipoDeudor === "IND") ? "" : s(info.sexo),
    estadoCivil: (tipoDeudor === "IND") ? "" : this.EstadoCivilTransUnion(s(cliente.estadoCivil || "")),

    direccionResidencial: this.limitarTexto(
       direccion,150),
    deptoResidencial:(tipoDeudor === "IND") ? "" : this.obtenerDepartamento(solicitud.sucursal || ""),
    munResidencial : (tipoDeudor === "IND") ? "" : s(cliente.municipio),

    direccionLaboral: (tipoDeudor === "IND") ? "" :    this.limitarTexto(cliente.puntoReferenciaNegocio || "", 150),
    deptoLaboral: (tipoDeudor === "IND") ? "" : s(cliente.departamentoTrabajo || ""),
    munLaboral:  (tipoDeudor === "IND") ? "" : s(cliente.municipioTrabajo || ""),

    email: s(cliente.email || ""),
    telResidencial: s(cliente.telefonoCasa || ""),
    telLaboral: (tipoDeudor === "IND") ? "" :s(cliente.telefono || ""),
    telCelular:   celular,

    tipoObligacion: "CMZ",
    moneda: "HNL",
    numeroObligacion: s(credito.id),

    fechaApertura: this.formatearFecha(credito.fechaOtorgamiento),
    fechaVencimiento: this.formatearFecha(credito.fechaVencimiento),
    periodoPago: this.PeriodoPagoTransUnion(s(solicitud.frecuenciaPago)),

    estado: this.EstadoTransUnion(credito.estado),
    subEstado: this.SubEstadoTransUnion(
      credito.estado,
      this.compareStrings(credito.estado, "cancelado") ? 0 : n(sim?.diasCuotaSinPagar)
    ),

    diasMora: this.compareStrings(credito.estado, "cancelado") ? 0 : n(sim?.diasCuotaSinPagar),

    valorLimite: s(credito.montoOtorgado),
    saldoTotal: this.formatoDosDecimales(sim?.minimoDebePagarCuota),
    saldoMora: s(saldoMora),
    valorCuota: s(credito.valorCuota),

    // ✅ IND
    tipoDeudor,

    nombreEntidad: "AXCC",
  });

  // ✅ Titular (IND)
  resultados.push(construirObjeto(nombresFull, s(cliente.dni), "DIR", cliente.puntoReferencia || cliente.referenciaGeografica || "", cliente.celular));

  return resultados;
});


  // Formatos de fecha
  const columnasFecha = ["fechaNacimiento", "fechaApertura", "fechaVencimiento", "fechaCastigo"];
  columnasFecha.forEach((key) => (worksheet.getColumn(key).numFmt = "dd/mm/yyyy"));

  // (Opcional) formatos numéricos
  const columnasDinero = [
    "valorLimite","saldoTotal","saldoMora","valorCuota","montoVencido","montoPagado","valorGarantia"
  ];
  columnasDinero.forEach((key) => (worksheet.getColumn(key).numFmt = '#,##0.00'));

  worksheet.addRows(mappedData);

  // Descargar
  workbook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("hidden", "");
    a.setAttribute("href", url);
    a.setAttribute("download", `TRANSUNION_${this.hoy ? this.hoy() : new Date().toISOString().slice(0,10)}.xlsx`);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  });
},

EstadoCivilTransUnion(estadoCivil) {
      switch (estadoCivil.toUpperCase()) {
        case 'SOLTERO':
          return 'SOL';
        case 'CASADO':
          return 'CAS';
        case 'DIVORCIADO':
          return 'DIV';
        case 'VIUDO':
          return 'VIU';
        case 'UNION LIBRE':
          return 'UNI';
        default:
          return '';
      }
    },

     obtenerDepartamento(valor) {
  if (!valor) return "x";

  const texto = valor
    .toUpperCase()
    .trim();

  const departamentos = [
    "ATLANTIDA",
    "COLON",
    "COMAYAGUA",
    "COPAN",
    "CORTES",
    "CHOLUTECA",
    "EL PARAISO",
    "FRANCISCO MORAZAN",
    "GRACIAS A DIOS",
    "INTIBUCA",
    "ISLAS DE LA BAHIA",
    "LA PAZ",
    "LEMPIRA",
    "OCOTEPEQUE",
    "OLANCHO",
    "SANTA BARBARA",
    "VALLE",
    "YORO"
  ];

  for (const depto of departamentos) {
    if (texto.includes(depto)) {
      return depto;
    }
  }

  return ""; // o "DESCONOCIDO"
},

formatearFecha(fecha) {
  const date = new Date(fecha);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
},
limitarTexto(valor, limite) {
  if (valor.length > limite) {
    return valor.slice(0, limite);
  }
  return valor;
},
 formatearIdentidad(valor) {
  const texto = String(valor).replace(/\D/g, ""); // elimina todo lo que no sea número



  const parte1 = texto.slice(0, 4);
  const parte2 = texto.slice(4, 8);
  const parte3 = texto.slice(8, 13);

  return `${parte1}-${parte2}-${parte3}`;
},

PeriodoPagoTransUnion(periodo) {
  if (!periodo) return '';

  const valor = periodo.trim().toUpperCase();

  switch (valor) {
    case 'SEMANAL':
      return 'SEM';
    case 'QUINCENAL':
      return 'QIN';
    case 'MENSUAL':
      return 'MEN';
    case 'BIMESTRAL':
      return 'BIM';
    case 'TRIMESTRAL':
      return 'TRI';
    case 'SEMESTRAL':
      return 'SMT';
    case 'ANUAL':
      return 'ANL';
    case 'AL VENCIMIENTO':
      return 'VEN';
    case 'OTRO':
      return 'OTR';
    default:
      return 'OTR';
  }
},


EstadoTransUnion(estado) {
  if (!estado) return '';

  const valor = estado.trim().toUpperCase();

  switch (valor) {
    case 'ACTIVO':
      return 'VIG';
    case 'VENCIDO':
      return 'VIG';
    case 'LEGAL':
      return 'VIG';
    case 'CANCELADO':
      return 'CAN ';
    case 'DEVUELTO':
      return '';
  }
},
SubEstadoTransUnion(estado, diasMora) {
  if (!estado) return '';

  const valor = estado.trim().toUpperCase();

  switch (valor) {
    case 'ACTIVO':
    case 'VENCIDO':

      if (diasMora === 0) {
        return 'DIA';
      }else if (diasMora > 0 && diasMora < 30) {
        return 'DIA';
      }else if (diasMora >= 30 && diasMora <= 89) {
        return 'MOR';
      }else if (diasMora >= 90 ) {
        return 'CJU';
      }
      break;

    case 'LEGAL':
      if (diasMora === 0) {
        return 'DIA';
      }else if (diasMora > 0 && diasMora < 30) {
        return 'DIA';
      }else if (diasMora == 30) {
        return 'MOR';
      }else if (diasMora > 30) {
        return 'CJU';
      }
      break;
    case 'CANCELADO':
      return 'VOL';
    case 'DEVUELTO':
      return '';
  }
},
formatoDosDecimales(valor) {
  return Number(valor).toFixed(2);
},



    getCreditosOptimizados() {

      Swal.fire({
        icon: "info",
        title: "La cartera se está descargando",
        html: `
    <div class="text-center">
      <div class="spinner-border text-info" style="width: 3rem; height: 3rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
      `,
        showConfirmButton: false,
      });
      const userRoles = Security.getUserSucursal();
      this.readyExcel = false

      const payload = {
        sucursal: this.sucursalFiltro,
        estado: this.estadoFiltro,
        asesor: Number.isNaN(parseInt(this.asesorFiltro, 10)) ? 0 : parseInt(this.asesorFiltro, 10),
        sucursales: this.sucursalFiltro === "MOSTRAR TODAS"
          ? [...(userRoles[0] || []), "SIN SUCURSAL"]
          : (userRoles[0] || [])
      }

      fetch(process.env.VUE_APP_API_URL + "/admin/credito/all", Security.requestOptions(payload))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            // this.$emit('error', response.message);

            console.error(response)
          } else {
            console.log('creditosOptimizados', response.data)

            this.creditosOptimizados = response.data.creditos.reverse()

            this.ready = true;
            this.creditos = response.data.creditos.reverse()
            console.log("Tamaño de cartera ", this.creditos.length);
            this.readyExcel = true;

            Swal.close()

            if(this.reporteFiltro === "PRINCIPAL"){
              this.handleImprimir()
            }else if(this.reporteFiltro === "TRANSUNION"){
              // Lógica para otro tipo de reporte
              this.handleImprimirTransUnion()

            }


          }
        })
        .catch(error => {
          this.$emit('error', error)
        })

    },

    hoy() {
      const today = new Date();
      const year = today.getFullYear();
      let month = today.getMonth() + 1; // Sumar 1 porque los meses comienzan desde 0
      let day = today.getDate();

      // Agregar un cero inicial si el mes o día es menor que 10 para mantener el formato 'YYYY-MM-DD'
      if (month < 10) {
        month = `0${month}`;
      }
      if (day < 10) {
        day = `0${day}`;
      }

      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate
    },


    infoRegistro() {
      fetch(process.env.VUE_APP_API_URL + `/admin/beneficiario-registro/${this.verMasData.cliente.dni}`, Security.requestOptions({}))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit('error', response.message);
            console.error(response.message)
          } else {
            console.log('Registro:', response)
            this.verMasData.infoRegistro = response.data
            console.log('Registro Ver mas data:', this.verMasData)

            // this.idCredito = response.data.id
            // this.readyVerMas = true
          }
        })
        .catch(error => {
          this.$emit('error', error)
        })
    },
    dateFormat(param) {

      var fechaISO = param;
      // Crear un objeto Date con la fecha proporcionada
      var fecha = new Date(fechaISO);

      // Obtener el día del mes (agregando un cero inicial si es necesario)
      var dia = ('0' + fecha.getUTCDate()).slice(-2);

      // Obtener el mes (agregando un cero inicial si es necesario)
      var mes = ('0' + (fecha.getUTCMonth() + 1)).slice(-2);

      // Obtener el año
      var anio = fecha.getUTCFullYear();

      // Formatear la fecha según tus necesidades
      var fechaFormateada = dia + '/' + mes + '/' + anio;

      // console.log(fechaFormateada); // Salida: 01/12/2023

      return fechaFormateada;

    },

    compareStrings(str1, str2) {
      // Convertir el primer string a minúsculas y eliminar los espacios
      str1 = str1.toLowerCase().replace(/\s/g, '');
      // Convertir el segundo string a minúsculas y eliminar los espacios
      str2 = str2.toLowerCase().replace(/\s/g, '');
      // Comparar los dos strings
      if (str1 === str2) {
        return true;
      } return false
    },



    mayusculasSinEspacios(texto) {
      return texto.toUpperCase().replace(/\s/g, '');
    },

  },

  watch: {
    nombreBanco: function (nombreBanco) {
      let numerosDeCuenta = this.bancos.find(banco => banco.nombreBanco === nombreBanco);

      this.numerosDeCuenta = numerosDeCuenta.cuentas;
    },

    esRefinanciado: function (newValue, oldValue) {
      if (this.verMasData.esRefinanciado != newValue) {
        Swal.fire({
          title: '¿Desea cambia el estado de Refinanciamiento?',
          icon: 'success',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirmar!'
        }).then((result) => {
          if (result.isConfirmed) {
            let payload = {
              idCredito: this.verMasData.id,
              esRefinanciado: this.esRefinanciado
            }

            console.log('confirmado')
            fetch(process.env.VUE_APP_API_URL + `/admin/credito/es-refinanciado`, Security.requestOptions(payload))
              .then((response) => response.json())
              .then((response) => {
                if (response.error) {
                  this.$emit('error', response.message);
                  console.error(response.message)
                } else {
                  console.log('Update', response)
                  // location.reload();
                  console.log('Se cambia', oldValue, "por", newValue);

                }
              })
              .catch(error => {
                this.$emit('error', error)
              })
          } else {
            this.esRefinanciado = oldValue
          }
        })
      }

    },

    estado: function (estado) {
      this.creditos = [];
      this.ready = false;
      const userRoles = Security.getUserSucursal();

      const payload = {
        sucursal: userRoles[0],
        estado: estado
      }

      if (this.sucursal != 'MOSTRAR TODAS') {
        payload.sucursal = this.sucursal
      }


      fetch(process.env.VUE_APP_API_URL + "/admin/credito/all", Security.requestOptions(payload))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit('error', response.message);

            console.error(response.message)
          } else {
            console.log('Creditos All:', response.data)

            this.creditos = response.data.creditos.reverse()
            this.ready = true;


          }
        })
        .catch(error => {
          this.$emit('error', error)
        })
    },

    fechaPagado(newValue, oldValue) {

      if (newValue >= this.fechaUltimoPago?.slice(0, 10)) {
        let payload = {
          idCredito: this.idCredito,
          fechaPagado: newValue,
          montoPagado: 0
        };
        this.hacerPagoInfo = {}
        fetch(process.env.VUE_APP_API_URL + `/admin/credito/simular-pago`, Security.requestOptions(payload))
          .then((response) => response.json())
          .then((response) => {
            if (response.error) {
              this.$emit('error', response.message);
              console.error(response.message);
            } else {
              console.log('Información del pago:', response);
              this.hacerPagoInfo = response.data;



            }
          })
          .catch(error => {
            this.$emit('error', error);
          });


      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La fecha no puede ser menor a la fecha del ultimo pago o mayor a la fecha actual',
        })
        this.fechaPagado = oldValue
      }


    }


  }
};
</script>

<style scoped>
.dashboard-action-btn {
  background: linear-gradient(120deg, #111827 0%, #1f2937 70%, #374151 100%);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  min-height: 42px;
  margin: 0;
}

.dashboard-action-btn:hover {
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(17, 24, 39, 0.2);
}
</style>
